import About from '../components/About/About'
import Contact from '../components/Contact/Contact'
import { StepEnum } from '../components/Content/types'
import Placeholder from '../components/Placeholder/Placeholder'
import Projects from '../components/Projects/Projects'
import Techs from '../components/Techs/Techs'

const useHandleComponent = () => {
  return {
    render: (currentStep: StepEnum) => {
      switch (currentStep) {
        case StepEnum.Placeholder:
          return <Placeholder />
        case StepEnum.About:
          return <About />
        case StepEnum.TechSkills:
          return <Techs />
        case StepEnum.Projects:
          return <Projects />
        case StepEnum.Contact:
          return <Contact />
        default:
          return <></>
      }
    },
  }
}

export default useHandleComponent
